import styled from 'styled-components'
// @ts-expect-error // TODO
import SvgUndoIcon from '../../assets/undo_mok-ikon.svg?react'
// @ts-expect-error // TODO
import SvgRedoIcon from '../../assets/redo_mok-ikon.svg?react'

export const OverlayControls = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
`

export const ModelControls = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 149px;
  pointer-events: none;
  position: absolute;
  top: 0;
  justify-content: space-between;
  align-items: flex-end;
  gap: 4px;

  @media (min-width: 1024px) {
    top: unset;
    flex-direction: column-reverse;
    bottom: 15px;
  }

  @media (min-width: 1200px) {
    height: 164px;
    left: 75px;
    justify-content: flex-start;
    gap: 8px;
  }

  button {
    pointer-events: auto;
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    background-color: #ffffff;

    @media (min-width: 1200px) {
      width: 50px;
      height: 50px;
    }

    &[disabled] {
      color: #d7d7d7;
      cursor: not-allowed;

      i {
        color: inherit;
      }
    }

    @media (hover: hover) {
      &:not([disabled]):hover {
        background-color: ${(props) => props.theme.palette.background.main};

        i {
          color: inherit;
        }
      }
    }

    i {
      font-size: 20px;
    }

    i {
      transform: translate(1px, 2px);
    }
  }

  &.undo,
  &.redo {
    i {
      transform: translate(1px, 2px);
    }
  }
`

export const ItemControls = styled.div`
  @keyframes hi-there {
    30% {
      transform: translateX(-50%) scale(1.15);
    }
    40%,
    60% {
      transform: translateX(-50%) rotate(-15deg) scale(1.15);
    }
    50% {
      transform: translateX(-50%) rotate(15deg) scale(1.15);
    }
    70% {
      transform: translateX(-50%) rotate(0deg) scale(1.15);
    }
    100% {
      transform: translateX(-50%) scale(1);
    }
  }

  pointer-events: none;
  position: absolute;
  left: 80%;
  transform: translateX(-50%);
  bottom: 15px;
  background-color: #c1dfc4;
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: hi-there 0.8s ease 0.4s 1;

  @media (min-width: 1200px) {
    left: unset;
    right: 45px;
  }

  button {
    pointer-events: auto;
    width: 38px;
    height: 38px;
    margin: 5px;
    background-color: transparent;
    border: none;
    padding: 0;

    @media (min-width: 1200px) {
      width: 50px;
      height: 50px;
    }

    @media (hover: hover) {
      &:hover {
        background-color: #a1cea6;

        &.is-active {
          background-color: #4f504a;
        }
      }
    }

    i {
      font-size: 20px;
    }

    &.is-active {
      background-color: #1d1d1b;

      i {
        color: #ffffff;
      }
    }
  }

  .button-divider {
    display: inline-block;
    width: 1px;
    height: calc(48px / 2.7);
    background-color: #afb0b3;

    @media (min-width: 1200px) {
      height: calc(60px / 2.7);
    }
  }
`

export const CameraZoomControls = styled.div`
  background-color: #ffffff;
  border: none;
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
  display: flex;
  flex-direction: column;
  width: fit-content;
`

export const HistoryControls = styled.div`
  background-color: #ffffff;
  border: none;
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-right: auto;

  button {
    padding: 0;
  }

  .button-divider {
    display: inline-block;
    width: 1px;
    height: 32px;
    background-color: #afb0b3;
    margin-top: 8px;

    @media (min-width: 1200px) {
      height: 34px;
      box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
    }
  }
`

export const UndoIcon = styled(SvgUndoIcon)`
  display: block;
  width: 32px;
  height: 32px;

  & path {
    fill: inherit;
  }

  &.disabled {
    & path {
      fill: #d7d7d7;
    }
  }
`

export const RedoIcon = styled(SvgRedoIcon)`
  display: block;
  width: 32px;
  height: 32px;

  & path {
    fill: inherit;
  }

  &.disabled {
    & path {
      fill: #d7d7d7;
    }
  }
`

export const ButtonDivider = styled.span<{
  $vertical?: boolean
}>`
  display: inline-block;
  height: ${(props) => (props.$vertical ? '32px' : '1px')};
  width: ${(props) => (props.$vertical ? '1px' : '32px')};
  background-color: #afb0b3;
  margin-left: ${(props) => (props.$vertical ? '0px' : '8px')};
  margin-top: ${(props) => (props.$vertical ? '8px' : '0px')};

  @media (min-width: 1200px) {
    width: ${(props) => (props.$vertical ? '1px' : '34px')};
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
  }
`

export const ToggleAnnotationsButton = styled.button<{
  showAnnotations?: boolean
}>`
  pointer-events: auto;
  background-color: #ffffff;
  border: none;
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
  display: flex;

  ${(props) =>
    props.showAnnotations &&
    `
          background-color: #1d1d1b;
          box-shadow: 0 3px 6px rgb(0 0 0 / 40%);
          `}

  @media (hover: hover) {
    &:hover {
      ${(props) => props.showAnnotations && 'background-color: #4f504a;'}
    }
  }

  i {
    ${(props) => props.showAnnotations && 'color: #ffffff;'}
  }
`

export const InsideOutSideToggleContainer = styled.div`
  pointer-events: auto;
  position: absolute;
  right: 0;

  @media (min-width: 1024px) {
    right: 40%;
  }
`
